<div class="extraction-result-container">
  <app-page-header></app-page-header>

  <!-- Page Header with Back Button -->
  <div class="page-content">
    <div class="content-section">
      <div class="evaluation-section-header">
        <div class="evaluation-section-title-wrap">
          <button
            class="section-back-btn"
            (click)="goBack()"
            [title]="getBackButtonTooltip()"
            [attr.aria-label]="getBackButtonTooltip()">
            <svg
              class="back-arrow-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <path d="M19 12H5"></path>
              <path d="M12 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h2 class="evaluation-section-title">Extraction Result</h2>
        </div>
        @if (selectedRun) {
          <p class="page-subtitle">
            <span>{{ selectedRun.fileName }}</span>
            <span>•</span>
            <span>{{ selectedRun.documentModel }}</span>
          </p>
        }
      </div>

  <!-- Main Content - Two Column Layout with Draggable Divider -->
  <div class="content-grid" [style.grid-template-columns]="'calc(' + splitPosition + '% - 10px) 20px calc(' + (100 - splitPosition) + '% - 10px)'">
    
    <!-- Column 1: PDF Viewer -->
    <section class="column viewer-column">
      <div class="card viewer-card">
        <div class="viewer-header-inline">
          <div class="header-title-group">
            <h3 class="card-title">PDF Preview</h3>
          </div>
          <div class="viewer-controls-inline" [class.controls-disabled]="extractionStatus === 'Running'">
            <div class="page-controls">
                <button class="control-btn" (click)="previousPage()" [disabled]="!pdfSrc || currentPage === 1 || extractionStatus === 'Running'" title="Previous Page">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <input 
                  type="text" 
                  class="page-input"
                  [(ngModel)]="pageInput"
                  (blur)="goToPage()"
                  (keydown)="onPageInputKeydown($event)"
                  [disabled]="!pdfSrc"
                  title="Go to page">
                <span class="page-separator">/</span>
                <span class="page-total">{{ totalPages || 0 }}</span>
                <button class="control-btn" (click)="nextPage()" [disabled]="!pdfSrc || currentPage === totalPages || extractionStatus === 'Running'" title="Next Page">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
              <div class="zoom-controls">
                <button class="control-btn" (click)="zoomOut()" [disabled]="!pdfSrc || zoom <= 0.5 || extractionStatus === 'Running'" title="Zoom Out">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                  </svg>
                </button>
                <input 
                  type="text" 
                  class="zoom-input"
                  [(ngModel)]="zoomPercentage"
                  (blur)="setZoomByPercentage()"
                  (keydown)="onZoomInputKeydown($event)"
                  title="Enter zoom percentage (50-300)">
                <span class="zoom-percent-sign">%</span>
                <button class="control-btn" (click)="zoomIn()" [disabled]="!pdfSrc || zoom >= 3.0 || extractionStatus === 'Running'" title="Zoom In">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    <line x1="11" y1="8" x2="11" y2="14"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                  </svg>
                </button>
                <button class="control-btn" (click)="rotatePdf()" [disabled]="!pdfSrc || extractionStatus === 'Running'" title="Rotate 90° clockwise">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M23 4v6h-6"></path>
                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="pdf-container" #pdfContainer (click)="onPdfContainerClick($event)">
            @if (!pdfSrc && !isLoadingPdf) {
              <div class="empty-state">
                <svg class="empty-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
                <p>No document loaded</p>
                <p class="empty-subtitle">PDF preview not available</p>
              </div>
            }

            @if (isLoadingPdf) {
              <div class="pdf-loading-state">
                <div class="loading-icon-wrapper">
                  <div class="spinner"></div>
                </div>
                <p class="loading-text">Loading document...</p>
              </div>
            }

            @if (pdfSrc && !isLoadingPdf) {
              <div class="pdf-viewer-wrapper">
                <pdf-viewer 
                  [src]="pdfSrc" 
                  [render-text]="true"
                  [original-size]="false"
                  [fit-to-page]="false"
                  [show-all]="true"
                  [page]="getPdfPageBinding()"
                  [zoom]="zoom"
                  [rotation]="0"
                  [autoresize]="true"
                  [stick-to-page]="false"
                  (after-load-complete)="onPdfDocumentLoad($event)"
                  (pageChange)="onPageChange($event)"
                  style="width: 100%; height: 100%;"
                ></pdf-viewer>
              </div>
            }
          </div>

      </div>
    </section>

    <!-- Draggable Divider -->
    <div class="resize-divider"
         (mousedown)="startResize($event)"
         [class.dragging]="isDragging"
         title="Drag to resize panels">
      <div class="divider-handle"></div>
    </div>

    <!-- Column 2: Extracted Data / Ground Truth -->
    <section class="column attributes-column">
      <div class="card extracted-data-card">
        <div class="card-header">
          <div class="header-title-group">
            <h3 class="card-title">
              Extracted Data
              @if (selectedRun && getTotalFieldsCount() > 0) {
                <span class="field-count">({{ getExtractedFieldsCount() }}/{{ getTotalFieldsCount() }})</span>
              }
            </h3>
          </div>
        </div>

        <!-- Search Bar -->
        @if (!fieldsLoading && extractedFields.length > 0) {
          <div class="search-bar-container">
            <input 
              type="text" 
              class="search-input" 
              [(ngModel)]="searchTerm"
              placeholder="Search field names..."
              title="Search by field name">
            @if (searchTerm) {
              <button class="clear-search-btn" (click)="searchTerm = ''" title="Clear search">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            }
          </div>
        }

          <!-- Loading State -->
        @if (fieldsLoading) {
          <div class="loading-state">
            <div class="spinner-small"></div>
            <p>Loading extracted data...</p>
          </div>
        }

        <!-- Fields Display -->
        @if (!fieldsLoading) {
          <div class="extracted-data-list">
            @if (getFilteredFields().length > 0) {
              @for (field of getFilteredFields(); track field.fieldName) {
                <!-- List Field Display -->
                @if (field.type === 'list') {
                  <div class="field-item" [class.extracted]="field.isExtracted" [class.empty]="!field.isExtracted">
                    <div class="field-header">
                      <span class="field-name">{{ field.fieldName }}</span>
                      <div class="field-badges">
                        @if (field.isAdditional) {
                          <span class="additional-badge" title="Not part of the field schema">Additional</span>
                        }
                        @if (field.isExtracted) {
                          @if (getListFieldBadgeLabel(field)) {
                            <span class="extracted-badge">{{ getListFieldBadgeLabel(field) }}</span>
                          }
                        } @else {
                          <span class="not-extracted-badge">Not Extracted</span>
                        }
                      </div>
                    </div>
                    @if (field.isExtracted) {
                      <div class="field-values">
                        @for (value of field.values; track $index) {
                          <div class="field-value">
                            <span class="value-text">{{ formatFieldValue(value) }}</span>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="field-empty-box"></div>
                    }
                  </div>
                }

                <!-- Table Field Display -->
                @if (field.type === 'table') {
                  <div class="table-item" [class.extracted]="field.isExtracted" [class.empty]="!field.isExtracted">
                    <div class="field-header">
                      <span class="field-name">{{ field.fieldName }}</span>
                      <div class="field-badges">
                        @if (field.isAdditional) {
                          <span class="additional-badge" title="Not part of the field schema">Additional</span>
                        }
                        @if (field.isExtracted) {
                          <span class="extracted-badge">Table ({{ field.rows.length }} rows)</span>
                        } @else {
                          <span class="not-extracted-badge">Not Extracted</span>
                        }
                      </div>
                    </div>
                    @if (field.isExtracted && field.rows.length > 0) {
                      <div class="table-wrapper">
                        <table class="extracted-table">
                          <thead>
                            <tr>
                              @for (column of field.columns; track column) {
                                <th class="table-header-cell">{{ column }}</th>
                              }
                            </tr>
                          </thead>
                          <tbody>
                            @for (row of field.rows; track $index) {
                              <tr class="table-row">
                                @for (column of field.columns; track column) {
                                  <td class="table-cell" [class.empty-cell]="!row[column]">
                                    {{ row[column] || '—' }}
                                  </td>
                                }
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    } @else {
                      <div class="field-empty-box"></div>
                    }
                  </div>
                }
              }
            } @else {
              <div class="empty-state-small">
                @if (searchTerm) {
                  <p>No fields matching "{{ searchTerm }}"</p>
                } @else {
                  <p>No extracted data available</p>
                }
              </div>
            }
          </div>
        }
      </div>
    </section>
    </div>
  </div>
</div>
